import React from "react";

const TimelineItem = ({ color, text, newItem }) => (
  <li className="flex items-center text-sm md:text-base">
    <span className={`mr-2 ${color}`}>•</span> {text}{" "}
    {newItem && <span className="text-green-500 ml-2">NEW</span>}
  </li>
);

export default TimelineItem;
